import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'app-input-form',
  templateUrl: './input-form.component.html',
  styleUrls: ['./input-form.component.scss'],
  standalone: false
})
export class InputFormComponent {
  @Input() control!: AbstractControl;
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() customClass: string = '';
  @Input() type: string = 'text';
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;
  @Input() clearInput: boolean = false;
  @Input() autocomplete?: string;
  @Input() showBorder: boolean = false;
  @Input() showIcon: boolean = false;
  @Input() icon?: string;
  @Input() fieldName?: string;

  @Output() valueChange = new EventEmitter<any>();

  get formControl(): FormControl {
    return this.control as FormControl;
  }

  get isValid(): boolean {
    return this.control.valid && !this.control.pristine;
  }

  get errorMessage(): string {
    if (this.control.invalid && (this.control.touched || this.control.dirty)) {
      const errors = this.control.errors;
      if (errors) {
        if (errors['backend']) return errors['backend']; 
        if (errors['required']) return 'Este campo es obligatorio.';
        if (errors['email']) return 'El correo electrónico no tiene un formato válido.';
        if (errors['minlength']) return `Mínimo ${errors['minlength'].requiredLength} caracteres.`;
        if (errors['maxlength']) return `Máximo ${errors['maxlength'].requiredLength} caracteres.`;
        if (errors['pattern']) return 'El formato ingresado no es válido.';
        if (errors['unique']) return 'Este valor ya está registrado.';
        if (errors['in']) return 'Seleccioná un valor válido.';
      }
    }
    return '';
  }
  

  get iconName(): string | null {
    if (!this.showIcon) return null;
    if (this.icon) return this.icon;
  
    switch (this.fieldName || this.type) {
      case 'email':
        return 'mail-outline';
      case 'tel':
      case 'phone':
      case 'number':
        return 'call-outline';
      case 'password':
        return 'lock-closed-outline';
      case 'fullname':
        return 'person-outline';
      case 'username':
        return 'at-outline';
      case 'dni':
        return 'card-outline';
      case 'gender':
        return 'male-female-outline';
      default:
        return null;
    }
  }
  
}
